// removed by extract-text-webpack-plugin
module.exports = {"post":"_2JR2p0LWUu59NqkvBI9ZwB_0","header":"_3WeFB6fhxHOKU97kZXlYXK_0","meta":"_1-sR7vekafNKlrEc3gdWyE_0","title":"cuLqMTM_NBEW_wNrIzOGS_0","body":"cO3adnejBovm91G82SrD9_0"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"extract":true,"remove":true}!./~/vue-style-loader!./~/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-rewriter.js?id=data-v-e60952fe!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Work.vue
// module id = 66
// module chunks = 2